import { render, staticRenderFns } from "./RoLogin.vue?vue&type=template&id=7567dac2&"
import script from "./RoLogin.vue?vue&type=script&lang=js&"
export * from "./RoLogin.vue?vue&type=script&lang=js&"
import style0 from "./RoLogin.vue?vue&type=style&index=0&id=7567dac2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports